import { useEffect, useState } from "react";
import TypeEntretienTable from "../../components/typesEntretien/typesEntretienTable";
import TypesEntretienForm from "../../components/typesEntretien/typesEntretienForm";
import {
  getEntretiens,
  createEntretien,
  deleteEntretien,
  updateEntretien
} from "../../api/typesEntretien.api";

export default function EntretienPage() {
  const [entretiens, setEntretiens] = useState([]);
  const [entretienEdit, setEntretienEdit] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  // 🔄 Charger les types d'entretiens
  useEffect(() => {
    loadEntretiens();
  }, []);

  const loadEntretiens = async () => {
    try {
      const res = await getEntretiens();
      setEntretiens(res.data);
    } catch (error) {
      console.error("Erreur chargement entretiens", error);
    }
  };

  // ➕ Ouvrir formulaire en mode ajout
  const handleOpenAdd = () => {
    setEntretienEdit(null);
    setFormOpen(true);
  };

  // ✏️ Ouvrir formulaire en mode édition
  const onEdit = (entretien) => {
    setEntretienEdit(entretien);
    setFormOpen(true);
  };

  // 🗑 Supprimer
  const onDelete = async (id) => {
    if (window.confirm("Supprimer ce type d'entretien ?")) {
      await deleteEntretien(id);
      loadEntretiens();
    }
  };

  // 💾 Create / Update
  const onSubmit = async (data) => {
    try {
      if (entretienEdit) {
        await updateEntretien(entretienEdit.id, data);
      } else {
        await createEntretien(data);
      }

      setEntretienEdit(null);
      setFormOpen(false);
      loadEntretiens();
    } catch (error) {
      console.error("Erreur sauvegarde entretien", error);
    }
  };

  // ❌ Fermer formulaire
  const onCancel = () => {
    setEntretienEdit(null);
    setFormOpen(false);
  };

  return (
    <div className="page-container">
      <h1>Liste des types d'entretiens</h1>

      <button onClick={handleOpenAdd} className="btn-add">
        Ajouter un type d'entretien
      </button>

      {formOpen && (
        <TypesEntretienForm
          onSubmit={onSubmit}
          entretien={entretienEdit}
          onCancel={onCancel}
        />
      )}
     {formOpen && (
          <button onClick={() => setFormOpen(false)} className="btn-close">
            Fermer
          </button>
        )}
      <TypeEntretienTable
        entretiens={entretiens}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </div>
  );
}
